import { TrainingConditionStatus } from '@dermloop/static-values';
import { Type } from 'class-transformer';
import {
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  Max,
  Min,
  ValidateNested,
} from 'class-validator';
import { DiagnosisDto } from '../diagnoses/diagnosis.dto';

/**
 * DTO used for requesting list data.
 */
export class ManageTrainingConditionListDto {
  selectedStatus?: TrainingConditionStatus | 'all';
  @Min(0)
  skip: number;
  @Max(20)
  @Min(1)
  take: number;
}

/**
 * Returned data after requesting list.
 */
export interface ManageTrainingConditionListResultDto {
  id: string;
  status: string;
  diagnosisName: string;
  locationName: string;
}
/**
 * DTO representing training condition for management.
 */
export interface ManageTrainingConditionDto {
  id: string;
  status: string;
  locationName: string;
  diagnosisIsHistopathological: boolean;
  primaryDiagnosis: DiagnosisDto;
  secondaryDiagnosis?: DiagnosisDto;
  clinicalImage: ManageTrainingConditionImageDto;
  baselineImage: ManageTrainingConditionImageDto;
  followUpImage: ManageTrainingConditionImageDto;
  additionalFollowUpImages?: ManageTrainingConditionImageDto[];
}

export interface ManageTrainingConditionImageDto {
  imageId: string;
  croppedIdentifier: string;
  imageUrl: string;
  createdDate: Date;
  isReferenceOnly?: boolean;
  isDiscarded?: boolean;
  focalPointXPercentage?: number;
  focalPointYPercentage?: number;
}

export class ManageTrainingConditionApproveDto {
  @IsString()
  @IsNotEmpty()
  @IsUUID()
  trainingConditionId: string;

  @IsOptional()
  @Type(() => ManageTrainingConditionUpdatedFocalPoint)
  @ValidateNested({ each: true })
  updateFocalPoints?: ManageTrainingConditionUpdatedFocalPoint[];
}

export class ManageTrainingConditionUpdatedFocalPoint {
  @IsString()
  @IsNotEmpty()
  @IsUUID()
  imageId: string;

  @IsNumber()
  newFocalPointX: number;

  @IsNumber()
  newFocalPointY: number;
}
